import { Link, Outlet, useLocation } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { useAuth } from '../hooks/useAuth.js';
import { Button } from './ui/button.js';

const NAV = [
  { to: '/admin', label: 'Übersicht' },
  { to: '/admin/workers', label: 'Worker' },
  { to: '/admin/clients', label: 'Kunden' },
  { to: '/admin/assignments', label: 'Einsätze' },
  { to: '/admin/absences', label: 'Abwesenheiten' },
  { to: '/admin/timesheets', label: 'Stunden' },
  { to: '/admin/surcharge-rule-sets', label: 'Zuschläge' },
  { to: '/admin/payroll-export', label: 'Lohn-Export' },
  { to: '/admin/deadlines', label: 'Fristen' },
  { to: '/admin/compliance', label: 'Compliance' },
  { to: '/admin/users', label: 'User & Rollen' },
  { to: '/admin/settings', label: 'Einstellungen' },
  { to: '/admin/audit', label: 'Audit-Log' },
] as const;

export function AdminLayout({ children }: { children?: ReactNode }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const path = location.pathname;

  return (
    <div className="min-h-screen flex">
      <aside className="w-56 border-r border-[var(--border)] bg-card p-4 flex flex-col gap-2">
        <div className="px-2 pb-4">
          <h2 className="font-semibold">Admin</h2>
          <p className="text-xs text-[var(--muted-foreground)] truncate">
            {user?.name ?? user?.email}
          </p>
          <p className="text-xs text-[var(--muted-foreground)]">
            Rolle: <span className="font-mono">{user?.role}</span>
          </p>
        </div>
        <nav className="flex flex-col gap-1">
          {NAV.map((item) => {
            const active =
              item.to === '/admin' ? path === '/admin' : path.startsWith(item.to);
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`px-3 py-2 rounded-md text-sm transition-colors ${
                  active
                    ? 'bg-[var(--secondary)] text-foreground'
                    : 'text-[var(--muted-foreground)] hover:bg-[var(--accent)] hover:text-foreground'
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>
        <div className="mt-auto">
          <Button variant="outline" size="sm" onClick={() => logout()}>
            Abmelden
          </Button>
        </div>
      </aside>
      <main className="flex-1 p-6 overflow-x-hidden">{children ?? <Outlet />}</main>
    </div>
  );
}
